/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { TGetPaymentUrlRequest, TGetPaymentUrlModel, IMappers, TGetPaymentUrlResponse } from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IV1GetPaymentUrlResponseSchema } from '../../entities/response/V1GetPaymentUrlResponseSchema';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createGetPaymentUrlModel(parameters: TGetPaymentUrlRequest): TGetPaymentUrlModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'legal-check',
    pathApi: '/v1/get-payment-url/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IGetPaymentUrlOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TGetPaymentUrlRequest;
}

export async function fetchGetPaymentUrl<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetPaymentUrlOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TGetPaymentUrlResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetPaymentUrlModel(parameters),
    config,
  )) as FetchResponse<TGetPaymentUrlResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IV1GetPaymentUrlResponseSchema, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TGetPaymentUrlResponse>;
}
